/* Joe Luxe "As it is": drag line between studio and real photo; arrows/dots switch
   pieces. The handle drifts once when the section first appears so people see it
   moves. Only clip/transform/opacity change. */
(function () {
  var roots = document.querySelectorAll('[data-jl-asis]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var stage = root.querySelector('[data-jl-asis-stage]');
    var knob = root.querySelector('[data-jl-asis-knob]');
    var slides = root.querySelectorAll('.jl-asis__slide');
    var dots = root.querySelectorAll('.jl-asis__dots i');
    var nameEl = root.querySelector('[data-jl-asis-name]');
    var codeEl = root.querySelector('[data-jl-asis-code]');
    var linkEl = root.querySelector('[data-jl-asis-link]');
    if (!stage || !slides.length) return;

    var x = 50;
    var index = 0;
    var dragging = false;
    var hinted = false;

    function set(v) {
      x = Math.max(0, Math.min(100, v));
      stage.style.setProperty('--x', x.toFixed(2) + '%');
      if (knob) knob.setAttribute('aria-valuenow', Math.round(x));
    }

    function fromEvent(e) {
      var r = stage.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }

    /* Moves only on a clear sideways drag or a tap, so a vertical scroll that
       starts on the image never jumps the line */
    var startX = 0;
    var startY = 0;
    var pressed = false;

    stage.addEventListener('pointerdown', function (e) {
      pressed = true;
      dragging = false;
      startX = e.clientX;
      startY = e.clientY;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      if (!dragging) {
        var dx = Math.abs(e.clientX - startX);
        var dy = Math.abs(e.clientY - startY);
        if (dx > 6 && dx > dy) {
          dragging = true;
          hinted = true;
          stage.classList.add('is-dragging');
          if (stage.setPointerCapture) stage.setPointerCapture(e.pointerId);
        } else {
          return;
        }
      }
      fromEvent(e);
    });
    stage.addEventListener('pointerup', function (e) {
      if (pressed && !dragging && Math.abs(e.clientX - startX) < 6 && Math.abs(e.clientY - startY) < 6) {
        hinted = true;
        fromEvent(e); /* tap to place the line */
      }
      pressed = false;
      dragging = false;
      stage.classList.remove('is-dragging');
    });
    stage.addEventListener('pointercancel', function () {
      pressed = false;
      dragging = false;
      stage.classList.remove('is-dragging');
    });

    if (knob) {
      knob.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { set(x - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { set(x + 5); e.preventDefault(); }
      });
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, k) {
        s.classList.toggle('is-on', k === index);
      });
      Array.prototype.forEach.call(dots, function (d, k) {
        d.classList.toggle('is-on', k === index);
      });
      var s = slides[index];
      if (nameEl) nameEl.textContent = s.getAttribute('data-name') || '';
      if (codeEl) codeEl.textContent = s.getAttribute('data-code') || '';
      if (linkEl && s.getAttribute('data-url')) linkEl.setAttribute('href', s.getAttribute('data-url'));
      set(50);
    }

    var prev = root.querySelector('[data-jl-asis-prev]');
    var next = root.querySelector('[data-jl-asis-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    /* One gentle drift so the handle reads as draggable */
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || hinted) return;
        hinted = true;
        io.disconnect();
        var t0 = null;
        function step(t) {
          if (dragging) return;
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / 1600);
          set(50 - Math.sin(k * Math.PI) * 16);
          if (k < 1) window.requestAnimationFrame(step);
        }
        window.setTimeout(function () { window.requestAnimationFrame(step); }, 350);
      }, { threshold: 0.6 });
      io.observe(stage);
    }
  });
})();
